<template>
  <div style="height: 100%">
    <div class="main-menu">
      <div
        class="main-menu__header__buttons"
        :class="[
          {'px-4': !miniDrawer},
          {'px-2': miniDrawer}
        ]"
      >
        <NewEmployeeDropdown v-if="hasAddEmployeeRole" :miniDrawer="miniDrawer" />

        <div v-if="hasBuyRideCouponRole && !miniDrawer" class="text-xs-center">
          <v-btn
            :to="{ name: 'BuyRideCoupon' }"
            color="accent"
            class="ma-0"
            depressed
            round
          >
            <span style="font-size: 12px;">
              {{ $t('Components.MainMenu.buyRideCoupon') }}
            </span>
          </v-btn>
        </div>
      </div>

      <div
        class="main-menu__wrapper"
        :class="[
          { 'main-menu__wrapper--employee-and-coupon-btn': hasAddEmployeeRole && hasBuyRideCouponRole },
          { 'main-menu__wrapper--only-new-employee-btn': hasAddEmployeeRole && !hasBuyRideCouponRole },
          { 'main-menu__wrapper--only-new-coupon-btn': !hasAddEmployeeRole && hasBuyRideCouponRole }
        ]"
      >
        <MenuItems :miniDrawer="miniDrawer" @handleMiniDrawer="handleMiniDrawer" />
        <WebCallButton :miniDrawer="miniDrawer" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { hasRole, isObject } from 'utils/functions'
import NewEmployeeDropdown from 'components/mainMenu/NewEmployeeDropdown'
import MenuItems from 'components/mainMenu/MenuItems'
import WebCallButton from 'components/mainMenu/WebCallButton'

export default {
  name: 'MainMenu',
  props: {
    miniDrawer: Boolean
  },
  components: {
    NewEmployeeDropdown,
    MenuItems,
    WebCallButton
  },
  computed: {
    ...mapState({
      company: ({ company }) => company.selectedCompany,
      claims: ({ userClaims }) => userClaims.claims
    }),

    routeName () {
      return this.$route.name
    },

    hasAddEmployeeRole () {
      return this.hasRole('employee', 'ROLE_POST_EMPLOYEE') ||
        this.hasRole('company', 'ROLE_POST_COMPANY_ID_EMPLOYEE_UPLOAD')
    },

    hasBuyRideCouponRole () {
      const companyPlan = this.isValidObject(this.company) && this.company.plan
        ? this.company.plan.toUpperCase()
        : null

      // return companyPlan === 'KA' && (this.hasRole('profiles', 'ROLE_CORPORATE_USER') || this.hasRole('profiles', 'ROLE_ADMINISTRATOR'))
      return companyPlan === 'KA' && this.hasRole('ui', 'UI_VIEW_COUPON_REQUEST')
    }
  },
  data () {
    return {
      namespace: 'Components.MainMenu'
    }
  },
  watch: {
    miniDrawer (to, from) {
      this.mainMenuToggle(from)
    }
  },
  methods: {
    ...mapActions({
      mainMenuToggle: 'mainMenu/toggle'
    }),

    handleMiniDrawer () {
      this.$emit('handleMiniDrawer')
    },

    hasRole (group, role) {
      return hasRole(group, role)
    },

    isValidObject (val) {
      return isObject(val)
    }
  }
}
</script>

<style lang="scss" scoped>
$icons: ('dashboards', 'employees', 'star', 'config', 'cost-center', 'projects', 'reports', 'financial', 'phone');
$icon-size: 24px;

.main-menu {
  padding-top: 16px;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  @media (min-width: 768px) {
     padding-top: 81px;
  }
}

.main-menu__header__buttons {
  margin-top: 39px;
}

.main-menu__wrapper {
 /*  bottom: 64px; */
  left: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 20px;
  flex: 1;
  right: 0;
  top: 115px;
  height: calc(100% - 210px);

  &::-webkit-scrollbar {
    width: 5px;
  }

  /* track */
  &::-webkit-scrollbar-track {
    background-color: $gray-7;
  }

  /* handle */
  &::-webkit-scrollbar-thumb {
    background-color: $gray-6;
    border-radius: 50px;
  }

  /* handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background-color: lighten($gray-6, 10);
  }

  &.main-menu__wrapper--employee-and-coupon-btn {
    top: 240px;
  }

  &.main-menu__wrapper--only-new-employee-btn {
    top: 110px;
    @media (min-width: 768px) {
     top: 186px;
    }
  }

  &.main-menu__wrapper--only-new-coupon-btn {
    top: 174px;
  }
}
</style>
